import PropTypes from 'prop-types'
import { applySpec, map, pathOr, pipe, values } from 'ramda'
import broadcastUtils from '../../utils/broadcast'
import s3LinkParser from '../../utils/s3-link'

const url = ({ livdemyId, type, url: bcUrl, version }) =>
  `/${livdemyId}/${
    broadcastUtils.getByType(type)?.route
  }/series/${bcUrl}/${version}`

const BroadcastSeriesPreview = applySpec({
  id: pathOr('', ['id']),
  cover: pipe(pathOr('', ['coverImage', 'location']), s3LinkParser),
  name: pathOr('', ['name']),
  classes: pipe(
    pathOr([], ['broadcastClasses']),
    values,
    map(
      applySpec({
        id: pathOr('', ['id']),
        name: pathOr('', ['name']),
        endTime: pathOr(0, ['endTime']),
        fee: pathOr(0, ['fee']),
      }),
    ),
  ),
  fee: pathOr(0, ['amount']),
  currency: pathOr('', ['currency']),
  discount: pathOr(0, ['discount']),
  url,
})

export const BroadcastSeriesPreviewPropTypes = PropTypes.shape({})

export default BroadcastSeriesPreview
